import { ImproveMyRiskPage } from "./improveMyRisk";

export const ImproveMyRisk = ImproveMyRiskPage;
